import { Outlet } from "react-router-dom";

import { useSidebar } from "@/hooks/use-sidebar";
import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";
import { Sidebar } from "./sidebar";
import { SidebarMobile } from "./sidebar-mobile";
import { TopbarMobile } from "./topbar-mobile";

/**
 * Authenticated app shell. Responsive layout:
 * - Mobile (<768px): hidden sidebar + hamburger top bar + slide-in
 * - Tablet + desktop (>=768px): persistent rail, 64px (collapsed)
 *   or 240px (expanded) controlled by an explicit toggle. Content
 *   margin tracks the rail width so nothing hides underneath it.
 */
export function Shell() {
  const { isCollapsed } = useSidebar();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:border focus:border-ocean-200 focus:bg-white focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-ocean-900 focus:shadow-sm"
      >
        {t("shared.skipToContent")}
      </a>
      <TopbarMobile />
      <SidebarMobile />
      <Sidebar />

      <main
        id="main-content"
        tabIndex={-1}
        className={cn(
          "transition-[margin-left] duration-200 ease-out focus:outline-none",
          isCollapsed
            ? "tablet:ml-sidebar-collapsed"
            : "tablet:ml-sidebar-expanded"
        )}
      >
        <div className="mx-auto px-4 py-6 tablet:px-6 desktop:px-8 desktop:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
